/**
 * Drawer Component
 */
import { LanguageModal } from './LanguageModal.js';

class DrawerMenuItem {
    constructor(element) {
        this.element = element;
        this.toggleBtn = element.querySelector('.no-drawer__menu-link');
        this.submenu = element.querySelector('.no-drawer__submenu');
        this.isOpen = false;

        if (this.toggleBtn && this.submenu) {
            this.init();
        }
    }

    init() {
        this.updateAriaAttributes();
        this.toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            const siblings = Array.from(this.element.parentElement.children);
            siblings.forEach(item => {
                if (item !== this.element) {
                    const menuItem = item.drawerMenuItemInstance;
                    if (menuItem && menuItem.isOpen) {
                        menuItem.close();
                    }
                }
            });
            this.open();
        }
    }

    open() {
        if (this.isOpen) return;

        this.isOpen = true;
        this.element.classList.add('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.updateAriaAttributes();

        if (this.toggleBtn) {
            this.toggleBtn.style.color = 'var(--clr-base-white)';
            this.toggleBtn.style.opacity = '1';
        }

        const submenuHeight = this.submenu.scrollHeight;
        this.submenu.style.maxHeight = submenuHeight + 'px';
    }

    close() {
        if (!this.isOpen) return;

        this.isOpen = false;
        this.element.classList.remove('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.updateAriaAttributes();

        if (this.toggleBtn) {
            this.toggleBtn.style.color = '';
            this.toggleBtn.style.opacity = '';
        }

        this.submenu.style.maxHeight = '0px';
    }

    updateAriaAttributes() {
        if (this.toggleBtn) {
            this.toggleBtn.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
        }
        if (this.submenu) {
            this.submenu.setAttribute('aria-hidden', this.isOpen ? 'false' : 'true');
        }
    }
}

export class Drawer {
    constructor() {
        this.container = document.getElementById('main-drawer');
        
        if (!this.container) {
            console.warn('Drawer: Container element not found');
            return;
        }

        this.menuItems = [];
        
        // 전역 인스턴스 설정
        window.drawerInstance = this;
        
        this.init();
    }

    init() {
        this.initMenuItems();
        this.initLanguageButton();
    }

    initMenuItems() {
        const menuItemElements = this.container.querySelectorAll('[data-menu-item].has-submenu');
        
        menuItemElements.forEach((element) => {
            const menuItem = new DrawerMenuItem(element);
            element.drawerMenuItemInstance = menuItem;
            this.menuItems.push(menuItem);
        });
    }

    initLanguageButton() {
        const drawerLanguageBtn = this.container.querySelector('#drawer-language-btn');
        if (drawerLanguageBtn) {
            drawerLanguageBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (window.languageModalInstance) {
                    window.languageModalInstance.open();
                }
            });
        }
    }

    closeAllSubmenus() {
        this.menuItems.forEach(item => {
            if (item.isOpen) {
                item.close();
            }
        });
    }
}

